var _rect, _path, _path2, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    role: "img",
    "aria-label": "Image indisponible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "#f5efe1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 H300 Q120 120 0 300 Z",
    fill: "#e45447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M800 600 H500 Q680 480 800 300 Z",
    fill: "#90acd1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400 268) scale(5.4) translate(-12 -12)",
    fill: "none",
    stroke: "#0f1936",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    x2: 22,
    y1: 2,
    y2: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.41 10.41a2 2 0 1 1-2.83-2.83"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    x2: 6,
    y1: 13.5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    x2: 21,
    y1: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15V5a2 2 0 0 0-2-2H9"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 408,
    textAnchor: "middle",
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#0f1936",
    fillOpacity: 0.78
  }, "Image indisponible")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderArticle);
export default __webpack_public_path__ + "static/media/placeholder-article.f56a327449819945d034369148978bf1.svg";
export { ForwardRef as ReactComponent };